import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";
import { nipValidation, zipCodeRegex } from "@ecp-boxes/helpers/helpers";

export const IBoxJoinTheCustomersMessagesScheme = z.object({
  nip_form_blocked_message: themeScheme.MessageScheme.default(
    "Próba odpytania bazy NIP zablokowane na minutę. Za chwilę spróbuj ponownie."
  ),
  nip_form_blocked_label: themeScheme.MessageScheme.default("Blokada na"),
  nip_form_blocked_label_time_unit: themeScheme.MessageScheme.default("min"),
  submit_button: themeScheme.MessageScheme.default("Dalej"),
  nip_form_header_company_found:
    themeScheme.MessageScheme.default("FIRMA / PODMIOT"),
  nip_form_warning_description: themeScheme.MessageScheme.default(
    "Wystąpił nieoczekiwany błąd. Spróbuj ponownie lub wróć później"
  ),
  nip_form_add_data_manually:
    themeScheme.MessageScheme.default("Dodaj dane ręcznie"),
  company_name_placeholder: themeScheme.MessageScheme.default("Firma / Podmiot"),
  street_placeholder: themeScheme.MessageScheme.default("Ulica"),
  street_number_placeholder: themeScheme.MessageScheme.default("Nr budynku / lokalu"),
  zip_code_placeholder: themeScheme.MessageScheme.default("Kod pocztowy"),
  city_placeholder: themeScheme.MessageScheme.default("Miasto"),
});

export const IBoxJoinTheCustomersSettingsScheme = z.object({
  nip_form_blocked_label_typo:
    themeScheme.TypoIdScheme.default("typo$$2").catch("typo$$2"),
  nip_form_blocked_label_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  nip_form_blocked_description_typo:
    themeScheme.TypoIdScheme.default("typo$$2").catch("typo$$2"),
  nip_form_blocked_description_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  join_the_customers_form_button_style:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  ecom_exist_url: themeScheme.UrlScheme.default("/ecom-exist").catch("/ecom-exist"),
  erp_exist_url: themeScheme.UrlScheme.default("/erp-exist").catch("/erp-exist"),
  say_more_url: themeScheme.UrlScheme.default("/company-additional-info").catch("/company-additional-info"),
});

export const JoinTheCustomersSchema = z.object({
  nip: z
    .string({ required_error: "Pole nie może być puste" })
    .length(10, {
      message: "Numer NIP jest niepoprawny. Popraw dane i spróbuj ponownie",
    })
    .refine((value) => nipValidation(value) !== "", {
      message: "Numer NIP jest niepoprawny. Popraw dane i spróbuj ponownie",
    }),
  companyName: z
    .string({ required_error: "Pole nie może być puste" })
    .min(1, { message: "Pole nie może być puste" })
    .max(50, { message: "Maksymalna liczba znaków to 50" }),
  street: z
    .string({ required_error: "Pole nie może być puste" })
    .min(1, { message: "Pole nie może być puste" })
    .max(50, { message: "Maksymalna liczba znaków to 50" }),
  houseApartmentNo: z
    .string({ required_error: "Pole nie może być puste" })
    .max(10, { message: "Maksymalna liczba znaków to 10" })
    .optional(),
  zipCode: z
    .string({ required_error: "Pole nie może być puste" })
    .length(5, {
      message: "Podaj poprawny kod pocztowy",
    })
    .refine((value) => zipCodeRegex.test(value), {
      message: "Podaj poprawny kod pocztowy",
    }),
  city: z
    .string({ required_error: "Pole nie może być puste" })
    .min(1, { message: "Pole nie może być puste" })
    .max(30, { message: "Maksymalna liczba znaków to 30" }),
});

export type TJoinTheCustomersForm = z.infer<typeof JoinTheCustomersSchema>;
